import React from "react";
import { useTranslation } from "react-i18next";

function LanguageToggle() {
  const { i18n } = useTranslation();

  const isEnglish = i18n.language === "en";

  const toggleLanguage = () => {
    const newLang = isEnglish ? "id" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("lang", newLang); // ✅ Save to localStorage
  };

  return (
    <div className="lang-toggle" onClick={toggleLanguage}>
      <div className={`circle ${isEnglish ? "right" : "left"}`}></div>
      <span className={(!isEnglish ? "active" : "") + " lang-id"}>ID</span>
      <span className={(isEnglish ? "active" : "") + " lang-en"}>EN</span>
    </div>
  );
}

export default LanguageToggle;
